<template>
  <div class="Product">
    <div class="img-holder">
      <img class="Product_img" :src="image" :alt="name">
    </div>

    <div class="Product_info">
      <h3 class="Product_name info_item" v-if="name">{{ name }}</h3>

      <slot name="independent-information"></slot>
      <slot name="popup-information-title"></slot>

      <div class="Product_popup">
        <p class="flex justify-content-between align-items-center" v-if="activeProductNumber">
          <span class="Product-summary-infos">
            {{ $t('common.product.info.number', 'Order number') }}
          </span>
          <span class="Product_popup_description">
            {{ activeProductNumber }}
          </span>
        </p>
        <div class="flex justify-content-between align-items-center" v-if="activeProductInfo">
          <span
            v-if="activeProductInfo.paymentBillingPeriod === 'Month'"
            class="Product-summary-infos">
            {{ $t('common.newProduct.price.monthlyCharge', 'Price per month') }}
          </span>
          <span
            v-if="activeProductInfo.paymentBillingPeriod === 'Quarter'"
            class="Product-summary-infos">
            {{ $t('common.newProduct.price.quarterlyCharge', 'Price per quarter') }}
          </span>
          <span
            v-if="activeProductInfo.paymentBillingPeriod === 'SemiAnnual'"
            class="Product-summary-infos">
            {{ $t('common.newProduct.price.semiAnnual', 'Price per semiAnnual') }}
          </span>
          <span
            v-if="activeProductInfo.paymentBillingPeriod === 'SpecificMonths'"
            class="Product-summary-infos">
            {{ $t('common.newProduct.price.specificMonths', { shippingSpecificMonthAmount: activeProductInfoshippingSpecificMonthAmount }) }}
          </span>
          <span class="Product_popup_description Product_popup_price">
            {{ activeProductInfo.paymentAmount | formatCurrency(true) }}
          </span>
        </div>
        <p class="flex justify-content-between align-items-center" v-if="activeProductPaymentDate">
          <span class="Product-summary-infos">
            {{ $t('common.product.info.nextPaymentDate', 'Next payment') }}
          </span>
          <span class="Product_popup_description">
            {{ activeProductPaymentDate }}
          </span>
        </p>
      </div>

      <div class="Product_content">
        <p class="Product_price info_item" v-if="oneTimeCharge.original">
          <span v-show="isBCBSSubscription === false" class="origin" :class="{ 'has-discount': oneTimeCharge.discounted !== oneTimeCharge.original }">
            {{ oneTimeCharge.original | formatCurrency }}
          </span>
            <span v-show="zeroamt" > $0.00   </span> 
          <span v-if="oneTimeCharge.discounted !== oneTimeCharge.original" class="discount">
            {{ oneTimeCharge.discounted | formatCurrency(true) }}
          </span>
          <span> / {{ $t('common.product.price.oneTimeCharge', 'one-time charge') }}</span>
        </p>
        <p class="Product_price info_item" v-if="monthlyCharge.original">
          <span v-show="isBCBSSubscription === false" class="origin" :class="{ 'has-discount': monthlyCharge.discounted !== monthlyCharge.original }">
            {{ monthlyCharge.original | formatCurrency }}
          </span>
           <span v-show="zeroamt" > $0.00 </span> 
          <span v-if="monthlyCharge.discounted !== monthlyCharge.original" class="discount">
            {{ monthlyCharge.discounted | formatCurrency(true) }}
          </span>
          <span> / {{ $t('common.product.price.monthlyCharge', 'monthly charge') }}</span>
        </p>
        <p class="Product_price info_item" v-if="quarterlyCharge.original">
          <span v-show="isbcbszero" class="origin" :class="{ 'has-discount': quarterlyCharge.discounted !== quarterlyCharge.original }">
            {{ quarterlyCharge.original | formatCurrency }}
          </span>
           <span v-show="zeroamt" > $0.00 </span> 
          <span  v-show="isbcbszero" v-if="quarterlyCharge.discounted !== quarterlyCharge.original" class="discount">
            {{ quarterlyCharge.discounted | formatCurrency(true) }}
          </span>
          <span> / {{ $t('common.product.price.quarterlyCharge', 'quarterly Charge') }}</span>
        </p>
        <p class="Product_price info_item" v-if="semiAnnualCharge.original">
          <span v-show="isBCBSSubscription === false" class="origin" :class="{ 'has-discount': semiAnnualCharge.discounted !== semiAnnualCharge.original }">
            {{ semiAnnualCharge.original | formatCurrency }}
          </span>
           <span v-show="zeroamt" > $0.00   </span>  
          <span  v-if="semiAnnualCharge.discounted !== semiAnnualCharge.original" class="discount">
            {{ semiAnnualCharge.discounted | formatCurrency(true) }}
          </span>
          <span> / {{ $t('common.product.price.semiAnnual', 'Semi annual') }}</span>
        </p>
        <p class="Product_price info_item" v-for="(specificCharge, index) in specificMonthsCharges" :key="index">
          <template v-if="specificCharge.amount.original">
            <span v-show="isBCBSSubscription === false" class="origin" :class="{ 'has-discount': specificCharge.amount.discounted !== specificCharge.amount.original }">
              {{ specificCharge.amount.original | formatCurrency }}
            </span>
             <span v-show="zeroamt" > $0.00 </span>
            <span v-if="specificCharge.amount.discounted !== specificCharge.amount.original" class="discount">
              {{ specificCharge.amount.discounted | formatCurrency(true) }}
            </span>
            <span> / {{ specificCharge.months }} {{ $t('common.product.price.specificMonths', 'months') }}</span>
          </template>
        </p>
        <p class="Product_price info_item" v-if="purchaseCharge.original">
          <span
            class="origin"
            :class="{ 'has-discount': purchaseCharge.discounted !== purchaseCharge.original }"
            v-html="$options.filters.formatCurrency(purchaseCharge.original, false, purchaseCharge.discounted === purchaseCharge.original)"
          ></span>
          <span
            v-if="purchaseCharge.discounted !== purchaseCharge.original"
            class="discount"
            v-html="$options.filters.formatCurrency(purchaseCharge.discounted, true, true)"
          ></span>
        </p>

        <slot name="below_price_information"></slot>

        <p class="Product_returnStatus info_item Product_info_align" v-if="returnInfoStatus && returnInfoStatus !== 'Not return'">
          <span>{{ $t('subscription_return.confirmation.returnStatus.text', 'Status') }}:</span>
          <span><i class="Product_returnCreateDate-warning">{{ $t(`subscription_return.confirmation.status.${returnInfoStatus.replace(/\s/gi, '-')}`, `${returnInfoStatus}`) }}</i></span>
        </p>
        <p class="Product_status info_item Product_info_align" v-if="replenshipmentReturningStatus">
          <span>{{ $t('subscription_details.onlyReplenishment.status.label', 'Status') }}: </span>
          <span class="Product_returnCreateDate-warning" :class="{'Product_canceled': replenshipmentReturningStatus==='Cancelled'}">
            {{ $t(`subscription_return.onlyReplenishment.status.${replenshipmentReturningStatus}`, `${replenshipmentReturningStatus}`) }}
          </span>
        </p>
        <p class="Product_status info_item Product_info_align" v-if="replenshipmentCancelStatus">
          <span>{{ $t('subscription_details.onlyReplenishment.status.label', 'Status') }}: </span>
          <span class="Product_returnCreateDate-warning" :class="{'Product_canceled': replenshipmentCancelStatus==='Cancelled'}">
            {{ $t(`subscription_return.onlyReplenishment.status.${replenshipmentCancelStatus}`, `${replenshipmentCancelStatus}`) }}
          </span>
        </p>
        <p class="Product_status info_item Product_info_align" v-if="deviceCancelStatus">
          <span>{{ $t('subscription_details.device.status.label', 'Status') }}: </span>
          <span class="Product_returnCreateDate-warning" :class="{'Product_canceled': deviceCancelStatus==='Cancelled'}">
            {{ $t(`subscription_return.device.status.${deviceCancelStatus}`, `${deviceCancelStatus}`) }}
          </span>
        </p>
        <p class="Product_status info_item Product_info_align" v-if="returningStatus">
          <span>{{ $t('subscription_details.onlyReplenishment.status.label', 'Status') }}: </span>
          <span class="Product_returnCreateDate-warning" :class="{'Product_canceled': returningStatus==='Cancelled'}">
            {{ $t(`subscription_return.onlyReplenishment.status.${returningStatus.replace(/\s/gi, '-')}`, `${returningStatus}`) }}
          </span>
        </p>
        <p class="Product_number info_item Product_info_align" v-if="number">
          <span>{{ $t('common.product.info.number', 'Number') }}:</span>
          <span>{{ number }}</span>
        </p>
        <p class="Product_replenishmentQuantity info_item Product_info_align align-items-center" v-if="replenishmentQuantity">
          <span>{{ $t('common.product.info.replenishmentQuantity', 'Replenishment Quantity') }}:</span>
          <span>{{ replenishmentQuantity }}</span>
        </p>
        <p class="Product_date info_item Product_info_align" v-if="startDate">
          <span>{{ $t('common.product.info.startDate', 'Start date') }}:</span>
          <span>{{ startDate | formatLocalDate }}</span>
        </p>
        <p class="Product_endDate info_item Product_info_align" v-if="endDate">
          <span>{{ $t('common.product.info.endDate', 'End date') }}:</span>
          <span>{{ endDate | formatLocalDate }}</span>
        </p>
        <p class="Product_nextPaymentDate info_item Product_info_align" v-if="nextPaymentDate">
          <span>{{ $t('common.product.info.nextPaymentDate', 'Next date') }}:</span>
          <span>{{ nextPaymentDate | formatLocalDate }}</span>
        </p>
        <p class="Product_nextShippingDate info_item Product_info_align" v-if="nextShipmentDate">
          <span>{{ $t('common.product.info.nextShipmentDate', 'Next Shipment') }}:</span>
          <span>{{ nextShipmentDate | formatLocalDate }}</span>
        </p>
        <p class="Product_status info_item Product_info_align" v-if="statusPend">
          <span>{{ $t('common.product.info.status', 'Status') }}:</span>
          <span><i class="statusPend">{{ $t(`common.product.info.status.${statusPend}`, `${statusPend}`) }}</i></span>
        </p>
        <p class="Product_status info_item Product_info_align" v-if="subscriptionDetailProductStatus">
          <span><i class="Product_canceled">{{ $t(`common.product.info.status.${subscriptionDetailProductStatus}`, `${subscriptionDetailProductStatus}`) }}</i></span>
        </p>
        <p class="Product_status info_item Product_info_align" v-if="statusRepend">
          <span>{{ $t('common.product.info.reStatus', 'Status') }}: </span>
          <span><b><i class="product_bold_text">{{ $t(`common.product.info.status.${statusRepend}`, `${statusRepend}`) }}</i></b></span>
        </p>
        <p class="Product_payInfullDate info_item Product_info_align" v-if="payInFullDate">
          <span>{{ $t('common.product.info.payinfullDate', 'Payinfull Date') }}: </span>
          <span>{{ payInFullDate | formatLocalDate }}</span>
        </p>
        <p class="Product_returnStatus info_item Product_info_align" v-if="deviceReturnStatus && deviceReturnStatus !== 'Not return'">
          <span>{{ $t('subscription_return.confirmation.status.label', 'Return status') }}: </span>
          <span class="Product_returnCreateDate-warning"><i>{{ $t(`subscription_return.confirmation.status.${deviceReturnStatus.replace(/\s/gi, '-')}`, `${deviceReturnStatus}`) }}</i></span>
        </p>
        <p class="Product_returnStatus info_item Product_info_align" v-if="replenshipmentReturnStatus && replenshipmentReturnStatus !== 'Not return'">
          <span>{{ $t('subscription_return.confirmation.status.label', 'Return status') }}: </span>
          <span class="Product_returnCreateDate-warning"><i>{{ $t(`subscription_return.confirmation.status.${replenshipmentReturnStatus.replace(/\s/gi, '-')}`, `${replenshipmentReturnStatus}`) }}</i></span>
        </p>
        <p class="Product_payInfullDate info_item Product_info_align" v-if="devicePurchaseDate">
          <span class="product_bold_text">{{ $t('common.product.info.devicePurchaseDate', 'Device purchased') }}: </span>
          <span>{{ devicePurchaseDate | formatLocalDate }}</span>
        </p>
        <p class="Product_returnCreateDate info_item Product_info_align" v-if="returnCreateDate">
          <span>{{ $t('subscription_return.confirmation.returnRequestDate.label', 'Cancellation request date') }}: </span>
          <span>{{ returnCreateDate | formatLocalDate }}</span>
        </p>
        <p class="Product_returnCreateDate info_item Product_info_align" v-if="deviceReturnCreateDate">
          <span>{{ $t('subscription_return.confirmation.deviceReturnRequestDate.label', 'Device return request date') }}: </span>
          <span>{{ deviceReturnCreateDate | formatLocalDate }}</span>
        </p>
        <p class="Product_returnCreateDate info_item Product_info_align" v-if="replenshipmentReturnCreateDate">
          <span>{{ $t('subscription_return.confirmation.replenshipmentReturnRequestDate.label', 'Replenishment return request date') }}: </span>
          <span>{{ replenshipmentReturnCreateDate | formatLocalDate }}</span>
        </p>
        <p class="Product_returnCreateDate info_item Product_info_align" v-if="replenshipmentReturnRequestDate">
          <span>{{ $t('subscription_return.confirmation.returnRequestDate', 'Cancellation requested') }}: </span>
          <span>{{ replenshipmentReturnRequestDate | formatLocalDate }}</span>
        </p>
        <p class="Product_returnCreateDate info_item Product_info_align" v-if="deviceReturnRequestDate">
          <span>{{ $t('subscription_return.confirmation.returnRequestDate', 'Cancellation requested') }}: </span>
          <span>{{ deviceReturnRequestDate | formatLocalDate }}</span>
        </p>
        <p class="Product_returnCreateDate info_item Product_info_align" v-if="returnRequestDate">
          <span>{{ $t('subscription_return.confirmation.returnRequestDate', 'Cancellation requested') }}: </span>
          <span>{{ returnRequestDate | formatLocalDate }}</span>
        </p>

        <p class="Product_shippingFrequency info_item Product_info_align" v-if="shippingFrequency">
          <span>
            {{ $t('common.product.info.shippingFrequency', 'Shipping frequency') }}:
          </span>
          <span>
            <span>{{ $t('subscription_details.onlyReplenishment.frequency.every', 'Every') }} </span>
            <span> {{ shippingFrequency.specificBillingPeriod ? `${shippingFrequency.specificBillingPeriod + ' '}` : '' }} </span>
            <span>{{ $t(`subscription_details.replenishment.frequency.type.${shippingFrequency.billingPeriod}`, `${shippingFrequency.billingPeriod}`) }}</span>
          </span>
        </p>

        <p class="Product_shippingFrequency info_item Product_info_align" v-if="listShippingFrequency">
          <span>
            {{ $t('common.product.info.shippingFrequency', 'Shipping frequency') }}:
          </span>
          <span>
            <span>{{ $t('subscription_details.onlyReplenishment.frequency.every', 'Every') }} </span>
            <span>{{ listShippingFrequency.specific ? `${listShippingFrequency.specific + ' '}` : '' }}</span>
            <span>{{ $t(`subscription_details.onlyReplenishment.frequency.type.${listShippingFrequency.type}`, `${listShippingFrequency.type}`) }}</span>
          </span>
        </p>

        <p class="Product_status info_item Product_info_align" v-if="deviceReturningStatus">
          <span>{{ $t('subscription_details.onlyReplenishment.status.label', 'Status') }}: </span>
          <span class="Product_returnCreateDate-warning" :class="{'Product_canceled': deviceReturningStatus==='Cancelled'}">
            {{ $t(`subscription_return.onlyReplenishment.status.${deviceReturningStatus.replace(/\s/gi, '-')}`, `${deviceReturningStatus}`) }}
          </span>
        </p>
        <p class="Product_nextShippingDate info_item Product_info_align" v-if="subscriptionDetailNextShipmentDate">
          <span>{{ $t('common.product.info.nextShipmentDate', 'Next Shipment') }}: </span>
          <span>{{ subscriptionDetailNextShipmentDate | formatLocalDate }}</span>
        </p>
        <p class="Product_nextShippingDate info_item Product_info_align" v-if="subscriptionDetailReplenishmentNextShipmentDate">
          <span>{{ $t('common.product.info.nextShipmentDate', 'Next Shipment') }}: </span>
          <span>-</span>
        </p>
        <p class="Product_nextShippingDate info_item Product_info_align" v-if="subscriptionDetailReplenishmentNextPaymentDate">
          <span>{{ $t('common.product.info.payinfullDate', 'Next Shipment') }}: </span>
          <span>-</span>
        </p>

        <p class="Product_returnStatus info_item Product_info_align" v-if="returnStatus && returnStatus !== 'Not return'">
          <span>{{ $t('subscription_return.confirmation.status.label', 'Return status') }}: </span>
          <span><i class="statusPend">{{ $t(`subscription_return.confirmation.status.${returnStatus.replace(/\s/gi, '-')}`, `${returnStatus}`) }}</i></span>
        </p>

        <p class="Product_text_success info_item font-weight-medium" v-if="successText">
          {{ successText }}
        </p>
        <p class="Product_tip info_item" v-if="vatText">
          {{ vatText }}
        </p>
        <p class="Product_description info_item" v-if="description" v-html="description"></p>

        <slot name="more-info"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'product',

    props: {
      name: {
        type: String,
        default: null
      },
      image: {
        type: String,
        default: null
      },
      description: {
        type: String,
        default: null
      },
      oneTimeCharge: {
        type: Object,
        default () {
          return {
            original: 0,
            discounted: 0
          }
        }
      },
      monthlyCharge: {
        type: Object,
        default () {
          return {
            original: 0,
            discounted: 0
          }
        }
      },
      quarterlyCharge: {
        type: Object,
        default () {
          return {
            original: 0,
            discounted: 0
          }
        }
      },
      semiAnnualCharge: {
        type: Object,
        default () {
          return {
            original: 0,
            discounted: 0
          }
        }
      },
      specificMonthsCharges: {
        type: Array,
        default () {
          return []
        }
      },
      vatText: {
        type: String,
        default: null
      },
      number: {
        type: String,
        default: null
      },
      startDate: {
        type: String,
        default: null
      },
      endDate: {
        type: String,
        default: null
      },
      nextPaymentDate: {
        type: String,
        default: null
      },
      payInFullDate: {
        type: String,
        default: null
      },
      returnCreateDate: {
        type: String,
        default: null
      },
      returnRequestDate: {
        type: String,
        default: null
      },
      replenshipmentReturnRequestDate: {
        type: String,
        default: null
      },
      deviceReturnRequestDate: {
        type: String,
        default: null
      },
      replenshipmentReturnCanceledDate: {
        type: String,
        default: null
      },
      deviceReturnCanceledDate: {
        type: String,
        default: null
      },
      nextShipmentDate: {
        type: String,
        default: null
      },
      subscriptionDetailNextShipmentDate: {
        type: String,
        default: null
      },
      subscriptionDetailReplenishmentNextShipmentDate: {
        type: [String, Boolean],
        default: null
      },
      subscriptionDetailReplenishmentNextPaymentDate: {
        type: [String, Boolean],
        default: null
      },
      statusPend: {
        type: String,
        default: null
      },
      subscriptionDetailProductStatus: {
        type: [String, Boolean],
        default: null
      },
      returnStatus: {
        type: [String, Object],
        default: null
      },
      deviceReturnStatus: {
        type: [String, Object],
        default: null
      },
      replenshipmentReturnStatus: {
        type: [String, Object],
        default: null
      },
      successText: {
        type: String,
        default: null
      },
      shippingFrequency: {
        type: Object,
        default: null
      },
      listShippingFrequency: {
        type: Object,
        default: null
      },
      replenishmentQuantity: {
        type: Number,
        default: null
      },
      purchaseCharge: {
        type: Object,
        default () {
          return {
            original: 0,
            discounted: 0
          }
        }
      },
      returningStatus: {
        type: String,
        default: null
      },
      deviceReturningStatus: {
        type: String,
        default: null
      },
      replenshipmentReturningStatus: {
        type: String,
        default: null
      },
      replenshipmentCancelStatus: {
        type: String,
        default: null
      },
      deviceCancelStatus: {
        type: String,
        default: null
      },
      returnInfoStatus: {
        type: [String, Object],
        default: null
      },
      returnInfoCreateDate: {
        type: String,
        default: null
      },
      deviceReturnCreateDate: {
        type: String,
        default: null
      },
      replenshipmentReturnCreateDate: {
        type: String,
        default: null
      },
      devicePurchaseDate: {
        type: String,
        default: null
      },
      statusRepend: {
        type: String,
        default: null
      },
      activeProductNumber: {
        type: String,
        default: null
      },
      activeProductInfo: {
        type: Object,
        default: null
      },
      activeProductPaymentDate: {
        type: String,
        default: null
      },
        isBCBSSubscription: {
        type: Boolean
      } 
    },
     computed: {  
         isbcbszero: function(){ 
        if(this.isBCBSSubscription === false){ 
          return true 
        } else {
         return false
       } 
    }, 
    zeroamt: function(){
          if(this.isBCBSSubscription !== false){
          return true 
       }  
      } 
    }
  }
</script>

<style lang="scss">
  .Product {
    padding: .1rem;
    display: flex;
    align-items: center;

    @include media(tablet) {
      max-width: 9.9rem;
      padding: .2rem 0;
    }

    .img-holder {
      display: inline-flex;
      flex: 1;
      width: 1.24rem;
      height: 1.24rem;
      align-items: center;
      justify-content: center;

      @include media(tablet) {
        width: 1.72rem;
        height: 1.72rem;
      }
    }

    &_img {
      max-height: 100%;
      max-width: 100%;
    }

    &_info {
      flex: 2;
      padding-left: .1rem;

      @include media(tablet) {
        padding: 0 .2rem;
      }

      .info_item {
        font-size: .14rem;
        line-height: .22rem;
        color: $font-dark-gray;
        font-weight: 400;
        letter-spacing: -0.0045rem;

        @include media(tablet) {
          font-size: .18rem;
          line-height: .25rem;
        }

        &.Product_price {
          font-weight: 700;
          line-height: .25rem;
          margin: 0 0 .12rem;
          font-size: .16rem;

          @include media(tablet) {
            font-size: .18rem;
            line-height: .28rem;
          }

          sup {
            top: -.25em;
          }

          .has-discount {
            position: relative;
            font-size: .14rem;
            font-weight: 500;
            margin-right: .025rem;

            &::before {
              content: "";
              position: absolute;
              border-top: .01rem solid $font-dark-gray;
              top: 50%;
              width: 95%;
              left: 2.5%;
              transform: rotate(-10deg);
            }
          }
        }

        &.Product_name {
          font-size: .18rem;
          font-weight: 700;
          color: $font-black;
          letter-spacing: -0.0035rem;

          @include media(tablet) {
            font-size: .25rem;
            line-height: .28rem;
          }
        }

        .Product_info_warnBold {
          color: #cd2a21;
          font-weight: bold;
          max-width: 60%;
        }

        .statusPend {
          color: #cd2a21;
        }

        .Product_canceled {
          color: #cd2a21;
          font-weight: 700;
          letter-spacing: -.0035rem;
        }

        .Product_returning {
          color: #de7510;
          font-weight: bold;
        }
      }
    }

    .Product_returnCreateDate-warning {
      color: #de7510;
      font-weight: bold;
    }

    .product_bold_text {
      font-weight: bold;
      color: #212121;
    }

    &_popup {
      .Product_info_align {
        width: 60%;
      }
    }
  }
</style>
